import en from './en.json';

export const I18N_NAMESPACE = 'ax-data-&-security';
export const I18N_RESOURCE = en;
export default I18N_RESOURCE;
